module.exports = __webpack_public_path__ + "static/media/living_kitchen_grey.0e93921f.jpg";